/* unplugin-vue-components disabled */import { render } from "./address_edit.vue?vue&type=template&id=4e03d616&scoped=true"
import script from "./address_edit.vue?vue&type=script&lang=js"
export * from "./address_edit.vue?vue&type=script&lang=js"

import "./address_edit.vue?vue&type=style&index=0&id=4e03d616&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e03d616"]])

export default __exports__